<template>
  <div class="slider__holder">
    <p class="slider__title">{{ value }}</p>
    <vue-slider
      ref="slider"
      v-model="value"
      v-bind="options"
      @callback="sliderSetRealValue"
    />
    <span class="slider__start">$0</span>
    <span class="slider__end">${{ parseInt(max).toLocaleString() }}</span>
  </div>
</template>
<script>
import vueSlider from 'vue-slider-component'
export default {
  components: {
    'vue-slider': vueSlider
  },
  props: {
    maxCashout: {
      type: Number,
      default: 1
    },
    selectedCashout: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      value: '0',
      options: {
        eventType: 'auto',
        width: 'auto',
        height: 14,
        dotSize: 30,
        dotHeight: null,
        dotWidth: null,
        min: 1,
        max: 10,
        interval: 1,
        tooltip: false,
        data: [
          ''
        ]
      },
      realValue: [],
      max: 0
    }
  },
  mounted: function () {
    let valueArr = (maxCashout) => {
      let arr = []
      arr.push(0)
      arr.push(2500)
      for (let i = 2; i < maxCashout; i++) {
        arr.push(arr[i - 1] + 5000)
      }
      return arr
    }
    let dataArr = (maxCashout) => {
      let arr = []
      arr.push('$0')
      for (let i = 0; i <= maxCashout; i = i + 5000) {
        arr.push('$' + i.toLocaleString() + ' - $' + (i + 5000).toLocaleString())
      }
      return arr
    }
    this.options.data = dataArr(this.maxCashout)
    this.realValue = valueArr(this.options.data.length)
    this.options.max = this.options.data.length
    this.value = this.options.data[2]
    this.max = this.maxCashout
    let realVal = this.realValue[2]
    if (this.selectedCashout) {
      this.value = this.options.data[this.realValue.indexOf(this.selectedCashout)]
      realVal = this.selectedCashout
    }
    this.$emit('input', realVal)
  },
  methods: {
    sliderSetRealValue: function (val) {
      const valueIndex = this.$refs.slider.getIndex()
      this.$emit('input', this.realValue[valueIndex])
    }
  }
}
</script>
